/**
 * The vehicle behind a transfer package, from the most people it seats.
 *
 * The supplier runs three vehicles (owner, 2026-09-23): a 4x4 for 1 to 3
 * people, a Mercedes van for 4 to 7 and a Mercedes Sprinter for 8 to 17. The
 * icon paths are host-relative: only apps/majourneys renders transfer forms,
 * and it serves them from public/images/transport.
 */
export interface TransferVehicle {
  /** Decorative cutout, 192x192 webp with a transparent background. */
  icon: string;
  /** i18n key for the vehicle's name. */
  nameKey: "transport.vehicle_4x4" | "transport.vehicle_van" | "transport.vehicle_sprinter";
}

export function transferVehicle(maxGuests: number): TransferVehicle {
  if (maxGuests <= 3) return { icon: "/images/transport/skoda.webp", nameKey: "transport.vehicle_4x4" };
  if (maxGuests <= 7) return { icon: "/images/transport/van.webp", nameKey: "transport.vehicle_van" };
  return { icon: "/images/transport/sprinter.webp", nameKey: "transport.vehicle_sprinter" };
}

/** Just the icon path; see `transferVehicle`. */
export function transferVehicleIcon(maxGuests: number): string {
  return transferVehicle(maxGuests).icon;
}
